/**
 * Phase 3b-3 — the legal-review-required badge.
 *
 * Some artifact types (e.g. the protest decision packet) frame a legal posture
 * for counsel and must not leave the studio as attorney-reviewed without an
 * actual attorney review. The label is intrinsic to the artifact type (stamped
 * server-side; see officegen.RequiresLegalReview), so this badge simply renders
 * whenever StudioAsset.legalReviewRequired / ArtifactTypeInfo.legalReviewRequired
 * is set.
 */ import { jsx as _jsx } from "react/jsx-runtime";
import { Badge } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
export function LegalReviewBadge() {
    return /*#__PURE__*/ _jsx(Badge, {
        variant: "destructive",
        title: "This artifact type requires attorney review before it can be approved",
        "data-testid": Testids.artifactStudio.legalReviewBadge,
        children: "Legal review required"
    });
}
